import React, { useState, useEffect, useRef } from 'react';

import moment from 'moment';

import { SelectionDetail } from '../../../../components/molecules';
import { useAppContext } from '../../../../AppProvider';
import { AccordionPayment } from '../../../../components/molecules/accordion';
import PreFooter from '../../../../components/molecules/pre-footer/PreFooter';
import Payform from '../../../../modules/step-payment/payform';
import { capitalize, getErrorPage } from '../../../../utils/helpers';
import {
  abortRequest,
  addRoute,
  getSession,
  suscriptionDps,
  uploadDps,
} from '../../../../services/clientServices';
import {
  requestAddRouteDps,
  requestUploadDps,
  requestSusDps,
  requestSession,
} from '../../../../services/requests';
import { additionalCoverages, mainCoverages } from '../../../../utils/constants';
import DynamicIcon from '../../../../components/atoms/DynamicIcon';
import RegisterAuditory from '../../../../auditory/component/RegisterAuditory';
import { AUDITORY_MODEL } from '../../../../models/step-payment';
import { useHistory } from '../../../../hooks/useHistory';

const StepPayment = () => {
  const {
    state,
    state: {
      planSelected,
      client,
      idQuote,
    },
    dispatch,
  } = useAppContext();

  const { navigate } = useHistory();
  const coverageSelected = { title: { head: 'RESUMEN DE TU COMPRA', headBox: 'PAGO MENSUAL', value: planSelected?.name }, price: planSelected?.price, client };
  const coverageRequired = mainCoverages.filter((_) => planSelected.mainCoveragesIds.some((c) => c === _.id));
  const coverageAdditional = additionalCoverages.filter((_) => planSelected.additionalCoveragesIds.some((c) => c === _.id));
  const [loading, setLoading] = useState(false);

  const [retriesRender, setRetriesRender] = useState(0);
  sessionStorage.setItem('retriesRender', retriesRender.toString());

  const updateSessionToken = () => {
    const totalRetriesRender = retriesRender + 1;
    if (totalRetriesRender >= 5) {
      return;
    }
    setRetriesRender(totalRetriesRender);
    sessionStorage.setItem('retriesRender', retriesRender.toString());
    getSession(requestSession(idQuote))
      .then((res) => {
        dispatch({ type: 'SAVE_SESSION', payload: res.sesion.token });
      })
      .catch((error) => {
        navigate(getErrorPage(error, 'GUARDAR_SESSION_PAGO'));
      });
  };

  const abortController = useRef({ signal: null, abort: abortRequest });
  const uploadDpsController = useRef({ signal: null, abort: abortRequest });

  const sendSignal = (signal) => {
    abortController.current.signal = signal;
  };

  useEffect(() => {
    let isMounted = true;
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 2);
    sessionStorage.removeItem('retriesRender');
    sessionStorage.removeItem('checkoutError');
    suscriptionDps(requestSusDps(state));
    uploadDps(requestUploadDps(state), sendSignal)
      .then((resp) => {
        addRoute(requestAddRouteDps(state, resp.payload), (signal) => {
          uploadDpsController.current.signal = signal;
        })
          .catch((error) => {
            if (isMounted) {
              navigate(getErrorPage(error, 'RUTA_DPS'));
            }
          });
      })
      .catch((error) => {
        if (isMounted) {
          navigate(getErrorPage(error, 'UPLOAD_DPS'));
        }
      });
    return () => {
      isMounted = false;
      abortController.current?.abort(abortController.current?.signal);
      uploadDpsController.current?.abort(uploadDpsController.current?.signal);
    };
  }, []);

  const nextStep = () => {
    setLoading(true);
  };

  const detailItems = [
    {
      id: 1,
      title: 'Plan elegido',
      subtitle: coverageSelected.title.value,
      icon: 'RideGlShieldSolid',
    },
    {
      id: 2,
      title: 'Asegurados',
      subtitle: '1 titular',
      icon: 'RideGlFamilySolid',
    },
    {
      id: 3,
      title: 'Vigencia de póliza',
      subtitle: '1 año con renovación automática',
      icon: 'RideGlCalendarSolid',
    },
  ];

  const [isTermsChecked, setIsTermsChecked] = useState(false);

  return (
    <div className="step-container content-payment">
      <RegisterAuditory authoring={AUDITORY_MODEL} />
      <div className="container">
        <div className="step-container-container">
          <div className="content-full">
            <div className="content-full__left">
              <div className="step-container-content">
                <h3 className="step-container-content_title">
                  Resumen y pago
                </h3>
                <div className="step-container-content_desc">
                  Por favor, verifica tu información antes de pagar.
                </div>
                <div className="step-container-content_mobile__data">
                  {detailItems.map((item) => (
                    <div key={item.id} className="data-item_row">
                      <div className="row-image">
                        <DynamicIcon icon={item.icon} size="medium" />
                      </div>
                      <div className="row-text">
                        <span className="text-title">{item.title}</span>
                        <span>{item.subtitle}</span>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="step-container-content_data">
                  <AccordionPayment title="Coberturas">
                    <ul>
                      {coverageRequired.map((item) => (
                        <li key={item.id}>
                          {item.text}
                        </li>
                      ))}
                      {coverageAdditional.map((item) => (
                        item.list.map((e) => (
                          <li key={`item-${e.id}`}>{e.text}</li>
                        ))
                      ))}
                    </ul>
                  </AccordionPayment>
                  <AccordionPayment title="Datos del titular">
                    <div>
                      <p className="accordion-payment_content--item">
                        Nombre:
                        <span className="list__value">
                          {` ${capitalize(client.nombres)}`}
                        </span>
                      </p>
                      <p className="accordion-payment_content--item">
                        Fecha de nacimiento:
                        <span className="list__value">
                          {` ${moment(client.fechaNacimiento).format('DD/MM/YYYY')}`}
                        </span>
                      </p>
                      <p className="accordion-payment_content--item">
                        {Number(client.tipoDocumento) === 2 ? 'DNI:' : 'CE:'}
                        <span className="list__value">
                          {` ${client.numeroDocumento}`}
                        </span>
                      </p>
                    </div>
                  </AccordionPayment>
                </div>
                <Payform
                  state={state}
                  updateSessionToken={updateSessionToken}
                  isTermsChecked={isTermsChecked}
                  setIsTermsChecked={setIsTermsChecked}
                />
              </div>
            </div>
            <div className="content-full__right">
              <SelectionDetail
                coverageSelected={coverageSelected}
                handleClick={() => nextStep()}
                loading={loading}
                id="pay"
                planSelected={planSelected}
                isPayment
                isTermsChecked={isTermsChecked}
              />
            </div>
          </div>
        </div>
        <PreFooter />
      </div>
    </div>
  );
};

export default StepPayment;
